function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.1453 12.0001L23.7705 1.34299C24.0861 1.02648 24.075 0.523127 23.7446 0.220377C23.4141 -0.0829017 22.8905 -0.0717867 22.5744 0.245254L12 10.8516L1.42558 0.245254C1.10891 -0.0717867 0.585344 -0.0829017 0.255428 0.220377C-0.0750397 0.523127 -0.0860737 1.02648 0.229498 1.34299L10.8547 12.0001L0.229498 22.6572C-0.0860737 22.9737 -0.0750397 23.4771 0.255428 23.7798C0.415973 23.927 0.621756 24 0.82754 24C1.04491 24 1.26283 23.918 1.42558 23.7549L12 13.1492L22.5744 23.7549C22.7372 23.918 22.9545 24 23.1725 24C23.3782 24 23.584 23.927 23.7446 23.7798C24.075 23.4771 24.0861 22.9737 23.7705 22.6572L13.1453 12.0001Z",
  fill: "#646464"
});

const SvgClose = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.747f51b6.svg";
export { ForwardRef as ReactComponent };